import { render, staticRenderFns } from "./TableRateLabel.vue?vue&type=template&id=5c7f1091&"
import script from "./TableRateLabel.vue?vue&type=script&lang=js&"
export * from "./TableRateLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports